import  React from 'react';
import {Query} from 'react-apollo';
import { GET_CURRENT_USER} from '../queries';


const withSession = Component => props => (
    <Query query = {GET_CURRENT_USER} >
        {({ data, loading, error, refetch, subscribeToMore}) => {
            if (loading) return null;  
            if (error) {
                window.open(`${process.env.SITE_ADDRESS}/noauth/`, '_top'); 
                return <div>error</div>;
            }         

            //console.log('localStorage.getItem(token)',localStorage.getItem('token'));

            if (localStorage.getItem('token')) {
                setInterval(function() {
                    if (localStorage.getItem('token') !== sessionStorage.getItem('DefaultToken')) {
                        console.log('Session Token Expired!');
                        setTimeout(() => window.open('https://artyfact.game/', '_top'), 1000);
                        sessionStorage.setItem('DefaultToken', '');
                        sessionStorage.setItem('SessionTime', '');
                        localStorage.setItem('token', '');
                        localStorage.setItem('tokenDefault', ''); 
                    }
                }, 3600 * 1000);
            }
            if (sessionStorage.getItem('SessionTime')) {
                let loginTime = new Date(sessionStorage.getItem('SessionTime'));
                setInterval(function() {
                    if (+new Date() > (+loginTime + 3600 * 4 * 1000)) {
                        console.log('Session Expired!');
                        setTimeout(() => window.open('https://artyfact.game/', '_top'), 1000);
                        sessionStorage.setItem('SessionTime', '');
                        sessionStorage.setItem('DefaultToken', '');
                        localStorage.setItem('token', '');
                        localStorage.setItem('tokenDefault', ''); 
                    }
                }, 3600 * 1 * 1000);
            }

            /*
            if (sessionStorage.getItem('SessionTime')) {
                let loginTime = new Date(sessionStorage.getItem('SessionTime'));
                //console.log('login-time: ', loginTime);
                //console.log('NOW: ', +new Date());
                //console.log('Max-time: ', +loginTime + 360 * 1 * 1000);

                setInterval(function() {
                    if (+new Date() > (+loginTime + 360 * 1 * 1000)) {
                        console.log('Session Expired!');
                        setTimeout(() => window.open('https://arno-token.com/', '_top'), 1000);
                        sessionStorage.setItem('SessionTime', '');
                        localStorage.setItem('token', '');
                        localStorage.setItem('tokenDefault', ''); 
                    }
                }, 3600 * 1000);
                
            }*/
            /*
            if (localStorage.getItem('tokenDefault')) {
                //console.log('localStorage.getItem(tokenDefault)', localStorage.getItem('tokenDefault'));
                if (localStorage.getItem('tokenDefault') !== localStorage.getItem('token')) {                    
                    localStorage.setItem('token', '');
                    localStorage.setItem('tokenDefault', '');    
                    location.reload();     
                    window.open('https://arno-token.com/', '_top');           
                }

                if (localStorage.getItem('email') && data.getCurrentUser) {
                    //console.log('email:', data.getCurrentUser.email);
                    //console.log('email-storage:', localStorage.getItem('email'));
                    if (localStorage.getItem('email') !== data.getCurrentUser.email) {     
                        localStorage.setItem('token', '');
                        localStorage.setItem('tokenDefault', '');   
                        location.reload();  
                        window.open('https://arno-token.com/', '_top');                   
                    }
                }
            } */           
                       
            return (
                <Component {...props} refetch={refetch} session = {data}
                           subscribeToMore={subscribeToMore}
                />
            )
        }}
    </Query>
);

export default withSession;
